export enum CorrectChargebackImportValuesType {
    HIN = 'HIN',
    DEA = 'DEA',
}